<template>
    <div class="home">
        <div class="snow-layer"></div>

        <div class="home-banner">

            <HomeBannerUser />
            <HomeBannerNews />

        </div>
        
        <div class="home-games">
            <div class="games-title">ALL GAMES</div>
            <div class="games-content">
                <HomeGameElement game="roll" />
                <HomeGameElement game="cases" />
                <HomeGameElement game="upgrader" />
                <HomeGameElement game="battles" />
                <HomeGameElement game="mines" />
                <HomeGameElement game="towers" />
                <HomeGameElement game="duels" />
                

            </div>
        </div>

        <HomeDepositMethods />
        <Bets />
    </div>
</template>

<script>
    import Bets from '@/components/bets/Bets';
    import HomeBannerUser from '@/components/home/HomeBannerUser';
    import HomeBannerNews from '@/components/home/HomeBannerNews'
    import HomeFeaturedLink from '@/components/home/HomeFeaturedLink';
    import HomeGameElement from '@/components/home/HomeGameElement';
    import HomePlaceholderElement from '@/components/home/HomePlaceholderElement';
    import HomeDepositMethods from '@/components/home/HomeDepositMethods';

    export default {
        name: 'Home',
        metaInfo: {
            title: 'Bloxify: The Ultimate R$ Gaming Experience.'
        },
        components: {
            Bets,
            HomeBannerUser,
            HomeBannerNews,
            HomeFeaturedLink,
            HomeGameElement,
            HomePlaceholderElement,
            HomeDepositMethods
        }
    }
</script>

<style scoped>
/* NOTE: All indentation is removed to prevent the "Unknown word" SyntaxError. */
.home{
width:100%;
position:relative;
display:flex;
flex-direction:column;
align-items:center;
padding:45px 10px;
}

.home .home-banner{
width:1250px;
display:flex;
flex-wrap:wrap;
}

.home .home-games{
width:1250px;
position:relative;
/* Adjusted padding to fit after removing home-featured */
padding:70px 0 40px 0;

}

.home .home-games::before{
content:'';
width:100%;
height:1px;
position:absolute;
top:0;
left:0;
background:linear-gradient(90deg,rgba(0, 140, 255, 0) 0%,#3b7eb7 50%,rgba(0, 140, 255, 0) 100%);
z-index:-1;
}

.home .home-games::after{
content:'';
width:100%;
height:1px;
position:absolute;
bottom:0;
left:0;
background:linear-gradient(90deg,rgba(0, 140, 255, 0.97) 0%,#5345a8 50%,rgba(0, 140, 255, 0.91) 100%);
}

.home .games-title{
width:205px;
height:43px;
position:absolute;
display:flex;
justify-content:center;
align-items:center;
top:0;
left:50%;
transform:translate(-50%, 30%);
font-size:24px;
font-weight:900;
color:#fff;
}

.home .games-title::before{
content:'';
width:100%;
height:100%;
position:absolute;
top:0;
left:0;
background:linear-gradient(255deg,#3b7eb7 -25%,#145081 100%);
clip-path:polygon(8px 0,calc(100% - 8px) 0,100% 25%,100% 75%,calc(100% - 8px) 100%,8px 100%,0 75%,0 25%);
z-index:-1;
}

.home .featured-content,
.home .games-content{
width:100%;
display:flex;
flex-wrap:wrap;
}

@media only screen and (max-width: 1600px){
.home .home-banner,
.home .home-games{
width:100%;
}
}

@media only screen and (max-width: 950px){
.home{
padding:25px 10px 443px 10px;
}
}

/* --- SNOWFALL EFFECT STYLES CORRECTED FOR TINY SIZE AND LOW DENSITY --- */

.snow-layer {
width: 100vw; 
height: 100%;
position: fixed;
top: 0;
left: 0;
pointer-events: none;
z-index: 99;
}

/* Generating Snowflakes (multiple layers for depth) */
.snow-layer {
background: transparent;
background-image: 
    /* Dot size reduced to 1% for tiny flakes */
    radial-gradient(white 1%, transparent 2%), 
    radial-gradient(white 1%, transparent 2%), 
    radial-gradient(white 1%, transparent 2%);

/* Pattern size INCREASED to reduce density (fewer flakes overall) */
background-size: 150px 150px, 200px 200px, 250px 250px; 

animation: 
    snow_fall 15s linear infinite,
    snow_sway 8s ease-in-out infinite alternate;
}

/* Vertical Fall Animation */
@keyframes snow_fall {
    0% { background-position: 0 0, 0 0, 0 0; }
    100% { background-position: 500px 1000px, 400px 1000px, 300px 1000px; }
}

/* Horizontal Sway Animation */
@keyframes snow_sway {
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(50px, 0, 0); }
}

/* --- END SNOWFALL EFFECT STYLES --- */
</style>